import React from 'react';

import FilterIcon from 'icons/ic-filter.svg';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';

import {
  DropdownIndicator,
  Option,
} from 'components/application/CollectionSelect';

export default function DivisionFilter({
  divisions,
  onChange,
  selectedDivisionId,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const defaultDivisionSelectionOption = {
    label: i18nTShared('allDivisions'),
    value: '',
  };

  const selectDivisionOptions = [defaultDivisionSelectionOption];

  divisions.forEach((division) =>
    selectDivisionOptions.push({
      label: division.attributes.name,
      value: division.id,
    }),
  );

  const selectedDivision =
    selectDivisionOptions.find(
      (option) => option.value === selectedDivisionId,
    ) || defaultDivisionSelectionOption;

  return (
    <div className='collection-select collection-select--inline-form'>
      <div className='form-group'>
        <Select
          autoFocus={false}
          className='collection-select__select-container'
          classNamePrefix='collection-select'
          components={{ SingleValue, DropdownIndicator, Option }}
          controlShouldRenderValue={true}
          isSearchable={true}
          name='divisionFilter'
          onChange={onChange}
          options={selectDivisionOptions}
          value={selectedDivision}
        />
      </div>
    </div>
  );
}

function SingleValue({ ...props }) {
  return (
    <components.SingleValue {...props}>
      <div
        className='collection-select__custom-value-container'
        style={{ display: props.selectProps.menuIsOpen ? 'none' : 'flex' }}
      >
        <div className='collection-select__filter-icon-wrapper tw-mr-2'>
          <FilterIcon height={20} width={10} />
        </div>
        <div className='collection-select__auto-content-wrapper'>
          <span className='truncated-text-container'>{props.children}</span>
        </div>
      </div>
    </components.SingleValue>
  );
}
